export default {
  brandManagement: {
    menu: {
      localMenu: {
        publishButton: 'Publish',
        publishSuccess: 'Menu menu published successfully.',
        menu: {
          createMenuButton: 'Create Menu',
          list: {
            noData: 'Nothing here yet',
            noDataInfo: 'There are no menus',
            categories: 'Categories: {total}',
            menuSize: {
              warnTooltip:
                'Menu near size limit\n{size} is close to the 6MB limit. Remove inactive items or modifiers to be sure the menu syncs',
              dangerTooltip:
                "Reduce menu size\nIt's over the 6MB limit and won't sync. Remove inactive items or modifiers to make space.",
            },
          },
          sidebar: {
            createTitle: 'Create New Menu',
            duplicateTitle: 'Duplicate {menu}',
            updateMenuTitle: 'Update {menu}',
            menuActionLabel: 'More',
            name: 'Menu Name',
            namePlaceholder: 'Create a name',
            image: 'Menu Image',
            primaryAction: 'Save',
            secondaryAction: 'Cancel',
            copiedSuccess: 'Copied Category ID',
            duplicate: 'Duplicate',
            duplicateInfo: `Duplicate menus share the same items as the original. Changing an item's info in the duplicate also updates it in the original.`,
            createSuccess: 'Menu Created Successfully',
            updateSuccess: 'Menu Updated Successfully',
            deleteSuccess: 'Menu Deleted Successfully',
            delete: {
              menuTabLabel: 'Delete',
              dialog: {
                header: 'Delete Confirmation',
                message:
                  'Are you sure you want to delete {RecordName}?\n This action cannot not be undone.',
                acceptLabel: 'Yes, delete',
                rejectLabel: 'No, cancel',
              },
            },
            subHeaders: {
              altLanguagesSettings: 'Alternative Languages',
            },
            altLanguages: {
              nameLabel: 'Menu name',
              namePlaceholder: 'Create a name',
            },
          },
          editCategory: 'Edit Category',
          category: {
            createCategoryButton: 'Create category',
            createItemButton: 'Create Item',
            activeSwitchValue: 'Active',
            inactiveSwitchValue: 'Inactive',
            list: {
              noData: 'Nothing here yet',
              noDataInfo: 'There are no categories',
            },
            sidebar: {
              createTitle: 'Create New Category',
              duplicateTitle: 'Duplicate {category}',
              updateTitle: 'Update {category}',
              menuActionLabel: 'More',
              name: 'Category Name',
              namePlaceholder: 'Create a name',
              image: 'Category Image',
              label: 'In-app name',
              labelPlaceholder: 'Add new or use category default name',
              status: 'Status',
              items: 'Items attached to this category',
              itemsPlaceholder: 'Search items for this category',
              primaryAction: 'Save',
              secondaryAction: 'Cancel',
              duplicate: 'Duplicate',
              duplicateInfo: `Duplicate categories share the same items as the original. Changing an item's info in the duplicate also updates it in the original.`,
              createSuccess: 'Category Created Successfully',
              updateSuccess: 'Category Updated Successfully',
              deleteSuccess: 'Category Deleted Successfully',
              delete: {
                menuTabLabel: 'Delete',
                dialog: {
                  header: 'Delete Confirmation',
                  message:
                    'Are you sure you want to delete {RecordName}?\n This action cannot not be undone.',
                  acceptLabel: 'Yes, delete',
                  rejectLabel: 'No, cancel',
                },
              },
              subHeaders: {
                altLanguagesSettings: 'Alternative Languages',
              },
              altLanguages: {
                nameLabel: 'Category name',
                namePlaceholder: 'Create a name',
              },
            },
            arrangeItem: 'Arrange items',
            addItem: 'Add Item',
            attachItem: 'Attach Item',
            itemTable: {
              loadingItemsProgress:
                'This category currently features over 500 items, with the remaining items being loaded in the background.',
              noItemsLine1: 'This category has no items',
              noItemsLine2: 'Please add some to use this category',
              displayingTotal: '{displayedItemsTotal} of {totalItems} items',
            },
            addItemSidebar: {
              createItem: 'Create',
              title: 'Add Item',
              primaryAction: 'Add',
              menuActionLabel: 'More',
              secondaryAction: 'Cancel',
              info: 'Select items to add to this menu category.',
              searchLabel: 'Search items to add',
              searchPlaceholder: 'Search by item name',
              selectedModifiers: 'Selected items',
              posid: 'POSID: ',
              recentResults: 'Recently added items',
              results: 'Results: {number}',
              noResultsInfo: "We didn't find any item that contains this query",
              selectState: 'Select',
              unselectState: 'Unselect',
              updateSuccess: 'Category Updated Successfully',
              clearFilter: 'Clear search',
              noData: 'Nothing here yet',
              noItems: 'No items available to add',
              noResults: 'Nothing found',
              allItemsTab: 'All Items',
              scannedItemsTab: 'Scanned Items',
            },
          },
        },
        modifiers: {
          createModifierButton: 'Create Modifier',
          containerWeightTooltip:
            'Container weight is the weight of the container provided with the food item. Also known as Tare weight.',
          noModifiers: 'No modifier groups are attached to this modifier',
          globalIndicatorTooltip: 'This relationship is inherited from a global parent',
          globalIndicatorAriaLabel: 'Global parent indicator for {entity}',
          globalIndicatorAriaDescription:
            'This relationship is inherited from a global parent for {entity}',
          removeModifierAriaLabel: 'Remove Modifier',
          restoreModifierAriaLabel: 'Restore Modifier',
          removeAttachmentTooltip: 'This will remove the modifier from this modifier group',
          restoreAttachmentTooltip: 'This will restore the modifier to this modifier group',
          editGroup: 'Edit Group',
          noModifiersToGroup: 'No modifiers attached to this group',
          bulkSidebar: {
            subHeaders: {
              modifier: 'Modifier',
              details: 'Details',
              priceManagement: 'Price management',
              reporting: 'Reporting',
              advanced: 'Advanced',
              bulkModifiers: 'Modifiers',
              bulkFieldsUpdating: "Fields you're updating",
              menuLabels: 'Menu Labels',
            },
            updateModifierTitle: '({number}) Bulk Update Modifier',
            reset: 'Reset',
            back: 'Back',
            multipleValues: '(Multiple values)',
            multiple: '(Multiple)',
            bulkReviewInfo:
              'Some modifiers belong to multiple items. Your updates will apply to each one.',
            bulkDeleteReviewInfo:
              'You are about to delete these modifiers. Please review and confirm that these are the changes you intend to make:',
            modifiers: 'Modifiers:',
            modifiersConfirmation: 'This changes will influence:',
            modifiersToDeleteConfirmation: 'This action will delete:',
            bulkConfirmationText: 'Are you sure you want to apply your changes?',
            bulkDeleteText: 'Are you sure you want to delete these modifiers?',
            bulkDeleteSuccess: 'Modifiers Deleted Successfully',
            checkboxConfirmation: 'I understand these changes cannot be undone.',
            accept: 'Yes, apply',
            cancel: 'No, cancel',
            noModifiersModified: 'There are no modifications to the selected modifiers.',
            alertNoModifiersAccept: 'Ok',
            updateSuccess: '{number} modifiers updated successfully',
            saveChanges: 'Save changes?',
            noModifiers:
              'The selected ({total}) modifiers do not share any identical modifier groups. Attach a group to them.',
            menuLabels: {
              label: 'Menu labels',
              description:
                'Labels help guests identify dietary needs and featured programs on menu items.',
              emptyMenuLabelsInfoText: 'To set up menu labels, go to global menu group settings.',
              defaultInfoText: '5 or fewer keeps items simple for guests to scan',
              noCommonMenuLabelsWarningText:
                'Some items may have menu labels added. Your selection will update all existing labels on these items.',
            },
          },
          modifierSidebar: {
            fullView: 'Full view',
            duplicateMenuLabel: 'Duplicate',
            updateModifierNameTitle: 'Update {modifier}',
            primaryAction: 'Save',
            secondaryAction: 'Cancel',
            menuActionLabel: 'More',
            modifierName: 'Default name',
            modifierNamePlaceholder: 'Create a name',
            label: 'In-app name',
            labelPlaceholder: 'Add new or use modifier default name',
            calories: 'Calories',
            caloriesPlaceholder: 'Add calories',
            containerWeight: 'Container Weight',
            weightAmount: 'Weight Amount',
            weightAmountPlaceholder: 'Add a value',
            weightUnit: 'Weight Unit',
            weightUnitPlaceholder: 'Select a unit',
            priority: 'Sequence in KDS',
            priorityPlaceholder: 'Add a sequence for KDS',
            posid: 'POSID',
            posidPlaceholder: 'POSID will be auto-generated',
            inStock: 'In Stock',
            description: 'Description on menu',
            descriptionPlaceholder: 'Add a description',
            status: 'Status',
            active: 'Active',
            inactive: 'Inactive',
            taxTags: 'Tax tags',
            taxTagsPlaceholder: 'None yet',
            taxTagsListAriaLabel: 'Tax tags list',
            groups: 'Modifiers attached',
            modifierGroups: 'Modifier groups attached',
            groupsPlaceholder: 'Search groups for this modifier',
            reportingCategory: 'Reporting category',
            reportingCategoryPlaceholder: 'Select a category',
            reportingCategoryListAriaLabel: 'Reporting category list',
            reportingSubCategory: 'Reporting subcategory',
            reportingSubCategoryPlaceholder: 'Search or type a subcategory',
            reportingSubCategoryNoResults:
              'No results for this criteria. This will create a new report subcategory.',
            reportingSubCategoryListAriaLabel: 'Reporting subcategory list',
            createSuccess: 'Modifier Created Successfully',
            updateSuccess: 'Modifier Updated Successfully',
            deleteSuccess: 'Modifier Deleted Successfully',
            image: 'Modifier image',
            modifierGroupSearch: 'Find modifier groups to attach',
            modifierGroupsPlaceholder: 'Search modifier groups for this modifier',
            kitchenRoute: 'Kitchen route',
            kitchenRoutePlaceholder: 'Select or create a kitchen route',
            kitchenRouteListAriaLabel: 'Kitchen route list',
            priceManagement: {
              title: 'Price management',
              price: 'Price',
              basePrice: 'Base price',
              pricePlaceholder: '$Put a price',
              priceTooltip:
                'The base price is the starting \nprice for this item. Price levels \nare added on top of it.',
              priceCaptionPriceLevels:
                'This item has {quantity} price level. Select {fullView} to edit it. | This item has {quantity} price levels. Select {fullView} to edit them.',
              priceCaptionNoPriceLevels:
                'This item has no price levels. Create price levels when you edit a menu group',
              priceCaptionFullView: 'Full View',
            },
            tabLabels: {
              general: 'General',
              modifiersGroups: 'Modifier Groups',
              menuLabels: 'Menu Labels',
            },
            delete: {
              menuTabLabel: 'Delete',
              menuTabLabelBulk: 'Delete All',
              dialog: {
                header: 'Delete Confirmation',
                message:
                  'Are you sure you want to delete {RecordName}?\n This action cannot not be undone.',
                acceptLabel: 'Yes, delete',
                rejectLabel: 'No, cancel',
              },
            },
            nextep: {
              preSurcharge: 'Nextep before surcharge price',
              postSurcharge: 'Nextep after surcharge price',
              preSurchargeTooltip:
                'Add a custom price to this modifier\n which is applied until the \n surcharge limit has been reached.\n Normal price by default.',
              postSurchargeTooltip:
                'Add a custom price to this modifier\n which is applied after the \nsurcharge limit has been reached.\n Normal price by default.',
              priceForLess: 'Price for less',
              priceForNone: 'Price for none',
              priceForSide: 'Price for side',
              priceForMore: 'Price for more',
              priceForExtra: 'Price for extra',
              selectionAlert: `You're unable to customize Nextep order type: {orderType}. Review modifier group settings for more options.`,
              orderBySelection: `Order by selection`,
              surchargeLimit: `Surcharge limit `,
              noSurchargeAlert:
                '{field} is disabled. Review modifier group settings for more options.',
            },
          },
          groups: {
            activeSwitchValue: 'Active',
            inactiveSwitchValue: 'Inactive',
            duplicateModifierGroupBtn: 'Duplicate modifier group',
            searchPlaceholder: 'Search group by name',
            all: 'All Modifiers',
            groupHeader: 'Modifier Groups',
            createGroupButton: 'Create a group',
            clearFilter: 'Clear search',
            noData: 'Nothing here yet',
            noResults: 'Nothing found',
            noDataInfo: 'There are no modifier groups',
            noResultsInfo: "We didn't find any group that contains this query",
            globalIndicatorTooltip: 'This relationship is inherited from a global parent',
            globalIndicatorAriaLabel: 'Global parent indicator for {entity}',
            globalIndicatorAriaDescription:
              'This relationship is inherited from a global parent for {entity}',
            removeAttachmentTooltip: 'This will remove the modifier group from this item',
            restoreAttachmentTooltip: 'This will restore the modifier group to this item',
            groupSidebar: {
              createGroupTitle: 'Create New Modifier Group',
              duplicateModifierGroupTitle: 'Duplicate {group}',
              duplicateModifierGroupBlurb:
                'Modifiers attached in this group will also be duplicated and assigned with different POSIDs',
              duplicateModifierWhenDuplicatingModifierGroup: 'Duplicate Modifiers',
              duplicateModifierWhenDuplicatingModifierGroupDescription:
                'Select to duplicate modifiers with new POSIDs',
              updateGroupTitle: 'Update {group}',
              primaryAction: 'Save',
              secondaryAction: 'Cancel',
              incremental: 'Incremental',
              status: 'Status',
              type: 'Nextep group type',
              groupName: 'Group Name',
              groupNamePlaceholder: 'Create a name',
              label: 'In-app name',
              labelPlaceholder: 'Add new or use modifier group default name',
              modifiersRange: 'Modifiers a guest can choose',
              min: 'Minimum',
              minPlaceholder: 'Minimum',
              max: 'Maximum',
              maxPlaceholder: 'Maximum',
              priority: 'Sequence in KDS',
              priorityPlaceholder: 'Add a sequence for KDS',
              items: 'Items attached in this group',
              groupsItems: 'Item using this modifier group | Items using this modifier group',
              itemsPlaceholder: 'Search items for this group',
              modifiers: 'Modifiers attached in this group',
              attachedModifiers: 'Modifiers attached',
              modifiersPlaceholder: 'Search modifiers for this group',
              minRangeError: 'Needs to be less than or equal Max',
              infinteItems: 'no limit',
              maxRangeError: 'Needs to be more than or equals Min',
              surchargeLimit: 'Surcharge limit',
              limitRangeError: 'Needs to be greater than or equal to min and less than max',
              limitLabel: '# of modifiers before surcharge apply',
              limitTooltip: `Guests will be charged the\n 'before surcharge price' until this\n amount is reached. After, the\n surcharge price will be applied.`,
              limitInfoSingular: 'surcharges applied after {total} selection',
              limitInfoPlural: 'surcharges applied after {total} selections',
              limitRequired: 'Needs to have a limit',
              createSuccess: 'Modifier Group Created Successfully',
              updateSuccess: 'Modifier Group Updated Successfully',
              deleteSuccess: 'Modifier Group Deleted Successfully',
              modifierSearch: 'Find modifiers to attach',
              itemsSearch: 'Find items to attach',
              menuActionLabel: 'More',
              noToggleSelectedError: 'Either surcharge limit or incremental must be toggled on.',

              tabLabels: {
                general: 'General',
                modifiers: 'Modifiers',
                items: 'Items',
              },
              subHeaders: {
                advancedSettings: 'Advanced Settings',
                nextepSettings: 'Nextep Settings',
                altLanguagesSettings: 'Alternative Languages',
              },
              nextep: {
                tooltip: 'You can update Nextep settings under Modifiers',
                quantityAlert: 'You can add before and after surcharge prices under {entity}',
                modifiers: 'Modifiers',
                optionAlert: 'You can add option prices under {entity}',
              },
              altLanguages: {
                nameLabel: 'Group name',
                namePlaceholder: 'Create a name',
              },
              orderType: {
                selection: 'Order by selection',
                selectionSubText: 'Choose from available options to customize item.',
                quantity: 'Order by quantity',
                quantitySubText: 'Specify quantities for each option.',
                option: 'Order by option',
                optionSubText: 'Customize selections with options like less or more.',
                confirmationHeader: 'Confirmation',
                confirmationInfo: `Changing your Nextep Order Type affects how guests can customize their items. \n Are you sure you want to change {modifierGroupName} to {orderType}?`,
                accept: 'Yes, change',
                cancel: 'Cancel',
              },
              optionSizing: {
                sizing: 'Nextep sizing option',
                sizingPlaceholder: 'Choose type',
                lessNormalMore: 'Less, normal, more',
                noneNormalExtra: 'None, normal, extra',
                sideNormalExtra: 'Side, normal, extra',
              },
              delete: {
                dialog: {
                  header: 'Delete Confirmation',
                  message:
                    'Are you sure you want to delete {RecordName}?\n This action cannot not be undone.',
                  acceptLabel: 'Yes, delete',
                  rejectLabel: 'No, cancel',
                },
              },
            },
            itemRangeLabelInfo: {
              fixed: 'Choose {number}',
              upTo: 'Choose up to {number}',
              atLeastUpTo: 'Choose at least {min}, up to {max}',
              atLeast: 'Choose at least {number}',
              any: 'Choose as many as you like',
            },
            itemRangeValidation: {
              max: 'You cannot choose more than {number} items for this group',
              atLeast: 'Choose at least {number} items for this group',
            },
            groupAddMod: {
              addMod1: 'Attach Modifier',
              addMod2: 'Attach a Modifier',
              create: 'Create',
              createModifierButton: 'Create Modifier',
              addModSidebar: {
                title: 'Attach a Modifier',
                info: 'Search and select an existing modifier to attach it to this group.',
                searchLabel: 'Search By Name',
                searchPlaceholder: 'Search modifier by name',
                selectedModifiers: 'Selected modifiers',
                posid: 'POSID: ',
                recentResults: 'Recently added Modifiers',
                results: 'Results: {number}',
                noResultsInfo: "We didn't find any modifier that contains this query",
                selectState: 'Select',
                unselectState: 'Unselect',
                primaryAction: 'Attach',
                secondaryAction: 'Cancel',
                menuActionLabel: 'More',
                noModifiers: 'No modifiers available to add',
              },
            },
          },
          table: {
            columns: {
              defaultName: 'Default name',
              posid: 'POSID',
              active: 'Status',
              inStock: 'In Stock',
              price: 'Price',
              basePrice: 'Base price',
              tags: 'Filter tags',
              updatedAt: 'Updated',
            },
            noModifiersLine1: 'This group has no modifiers',
            noModifiersLine2: 'Please add some to use this group',
            tableEmpty: 'Nothing Here Yet',
            tableLoading: 'Loading modifiers data. Please wait.',
            pageReport: "{'{first}'} - {'{last}'} of {'{totalRecords}'} modifiers",
            expandRowAriaLabel: 'Expand row',
            collapseRowAriaLabel: 'Collapse row',
            globalIndicatorAriaLabel: 'Global parent indicator for {entity}',
            globalIndicatorAriaDescription:
              'This relationship is inherited from a global parent for {entity}',
            globalIndicatorTooltip: 'This relationship is inherited from a global parent',
            filters: {
              itemNamePlaceholder: 'Search modifier by name',
              posidPlaceholder: 'Search by POSID',
              pricePlaceholder: 'Search by price',
              filterPlaceholder: 'Search',
              isActivePlaceholder: 'All',
              isInStockPlaceholder: 'All statuses',
              updatedAtPlaceholder: 'Last Updated',
              tagsPlaceholder: 'All tags',
              isActive: 'Active',
              isNotActive: 'Inactive',
              isInStock: 'In Stock',
              isNotStock: 'Not In Stock',
              tags: 'tag | tags',
            },
          },
        },
        items: {
          pageTitle: 'Local Menu Items',
          containerWeightTooltip:
            'Container weight is the weight of the container provided with the food item. Also known as Tare weight.',
          createSuccess: 'Item Created Successfully',
          updateSuccess: 'Item Updated Successfully',
          deleteSuccess: 'Item Deleted Successfully',
          createItemButton: 'Create Item',
          attachCpgItemBtn: 'Attach CPG',
          noModifiers: 'No modifier groups are attached to this item',
          bulkSidebar: {
            subHeaders: {
              item: 'Item',
              details: 'Details',
              priceManagement: 'Price management',
              reporting: 'Reporting',
              advanced: 'Advanced',
              items: 'Items',
              fieldsUpdating: "Fields you're updating",
              menuLabels: 'Menu Labels',
            },
            updateItemTitle: '({number}) Bulk Update Item',
            multipleValues: '(Multiple values)',
            multiple: '(Multiple)',
            reset: 'Reset',
            back: 'Back',
            bulkReviewInfo:
              'Some items belong to multiple categories. Your updates will apply in each one.',
            bulkDeleteReviewInfo:
              'You are about to delete these items. Please review and confirm that these are the changes you intend to make:',
            itemsConfirmation: 'This changes will influence:',
            itemsToDeleteConfirmation: 'This action will delete:',
            bulkConfirmationText: 'Are you sure you want to apply your changes?',
            modifierGroupsLabel: 'Common modifier groups attached',
            bulkDeleteText: 'Are you sure you want to delete these items?',
            bulkDeleteSuccess: 'Items Deleted Successfully',
            checkboxConfirmation: 'I understand these changes cannot be undone.',
            accept: 'Yes, apply',
            cancel: 'No, cancel',
            noItemsModified: 'There are no modifications to the selected items.',
            alertNoItemsAccept: 'Ok',
            updateSuccess: '{number} items updated successfully',
            noModifiers:
              'The selected ({total}) items do not share any identical modifier groups. Attach a group to them.',
            menuLabels: {
              label: 'Menu labels',
              description:
                'Labels help guests identify dietary needs and featured programs on menu items.',
              emptyMenuLabelsInfoText: 'To set up menu labels, go to global menu group settings.',
              defaultInfoText: '5 or fewer keeps items simple for guests to scan',
              noCommonMenuLabelsWarningText:
                'Some items may have menu labels added. Your selection will update all existing labels on these items.',
            },
          },
          sidebar: {
            tabLabels: {
              general: 'General',
              modifierGroups: 'Modifier Groups',
              menuWorks: 'Menuworks',
              aiTools: 'Ai tools',
              menuLabels: 'Menu Labels',
            },
            jwoTaxCodeLabel: 'JWO tax code',
            jwoTaxCodeListAriaLabel: 'JWO tax code list',
            jwoTaxCodePlaceholder: 'Select tax code',
            active: 'Active',
            inactive: 'Inactive',
            createItemTitle: 'Create New Item',
            updateItemTitle: 'Update Item',
            updateItemTitleName: 'Update {item}',
            duplicateMenuLabel: 'Duplicate',
            duplicateItemTitle: 'Duplicate {item}',
            duplicateItemBtn: 'Duplicate item',
            fullView: 'Full view',
            status: 'Status',
            featured: 'Suggest item at Checkout',
            featuredTag: 'Suggested at checkout',
            inStock: 'In Stock',
            uploadImageLabel: 'Item Image',
            name: 'Default name',
            namePlaceholder: 'Create a name',
            label: 'In-app name',
            labelPlaceholder: 'Add new or use item default name',
            priceManagement: {
              title: 'Price management',
              price: 'Price',
              basePrice: 'Base price',
              pricePlaceholder: '$Put a price',
              priceTooltip:
                'The base price is the starting \nprice for this item. Price levels \nare added on top of it.',
              priceCaptionPriceLevels:
                'This item has {quantity} price level. Select {fullView} to edit it. | This item has {quantity} price levels. Select {fullView} to edit them.',
              priceCaptionNoPriceLevels:
                'This item has no price levels. Create price levels when you edit a menu group',
              priceCaptionFullView: 'Full View',
            },
            mealValue: 'Meal value',
            mealValuePlaceholder: 'Add meal value',
            posid: 'POSID',
            posidPlaceholder: 'POSID will be auto-generated',
            barcode: 'Barcode',
            barcodePlaceholder: 'Add barcode',
            calories: 'Calories',
            caloriesPlaceholder: 'Add calories',
            containerWeight: 'Container Weight',
            weightAmount: 'Weight Amount',
            weightAmountPlaceholder: 'Add a value',
            weightUnit: 'Weight Unit',
            weightUnitPlaceholder: 'Select a unit',
            modifierGroupSearch: 'Find modifier groups to attach',
            modifierGroupsPlaceholder: 'Search modifier groups for this item',
            modifierGroupsEmptyState: 'Nothing here!',
            reportingCategory: 'Reporting category',
            reportingCategoryPlaceholder: 'Select a category',
            reportingCategoryListAriaLabel: 'Reporting category list',
            reportingSubCategory: 'Reporting subcategory',
            reportingSubCategoryPlaceholder: 'Search or type a subcategory',
            reportingSubCategoryNoResults:
              'No results for this criteria. This will create a new report subcategory.',
            reportingSubCategoryListAriaLabel: 'Reporting subcategory list',
            kitchenRoute: 'Kitchen route',
            kitchenRoutePlaceholder: 'Select or create a kitchen route',
            kitchenRouteListAriaLabel: 'Kitchen route list',
            priority: 'Sequence in KDS',
            priorityPlaceholder: 'Add a Sequence for KDS',
            taxTags: 'Tax tags',
            taxTagsPlaceholder: 'None yet',
            taxTagsListAriaLabel: 'Tax tags list',

            description: 'Description on menu',
            generateDescription: 'Generate description',
            generateDescriptionNoLabelError:
              "Enter 'In-app name' to enable description generation.",
            generateDescriptionEnabledTooltip:
              "Use AI to craft a compelling description based on the 'In-app name' and item modifiers. Note that the AI's interpretation may vary with complex or abstract ideas.",
            generateImage: 'Generate an image',
            generateImageNoDescriptionError: 'Enter item description to enable image generation.',
            generateImageEnabledTooltip:
              "Use AI to generate an image based on the item description. For optimal results, input a detailed and concise description. Note that the AI's interpretation may vary with complex or abstract ideas.",
            descriptionPlaceholder: 'Add a description',
            primaryAction: 'Save',
            secondaryAction: 'Cancel',
            menuActionLabel: 'More',
            advancedSettingsTitle: 'Advanced Settings',
            delete: {
              menuTabLabel: 'Delete',
              menuTabLabelBulk: 'Delete All',
              dialog: {
                header: 'Delete Confirmation',
                message:
                  'Are you sure you want to delete {RecordName}?\n This action cannot not be undone.',
                acceptLabel: 'Yes, delete',
                rejectLabel: 'No, cancel',
              },
            },
            itemRangeValidation: {
              max: 'You cannot choose group {name} as reached max items',
            },
          },
          sequencingDialog: {
            header: 'Arrange items',
            details: 'Move items into the order you want them to appear in apps and kiosks.',
            cancel: 'Cancel',
            save: 'Update arrangement',
          },
          table: {
            title: 'All Items',
            deleted: 'Deleted',
            globalIndicatorTooltip: 'This relationship is inherited from a global parent',
            globalIndicatorAriaLabel: 'Global parent indicator for {entity}',
            globalIndicatorAriaDescription:
              'This relationship is inherited from a global parent for {entity}',
            removeAttachmentTooltip: 'This will remove the item from this category',
            restoreAttachmentTooltip: 'This will restore the item to this category',
            header: {
              selectColumnsAriaLabel: 'Select columns for the category to item table',
              selectColumnsPlaceholder: 'Select columns',
              nameGroupLabel: 'Name (at least 1 is required)',
              optionalGroupLabel: 'Optional',
              columnsShowingLabel: '{count} column showing | {count} columns showing',
              columnsSaveFailedToast: "Column selections won't save",
              columnsSaveFailedToastDetail:
                "Your browser can't store them right now. Select again when you return",
            },
            filters: {
              defaultNamePlaceholder: 'Search by default name',
              inAppNamePlaceholder: 'Search by in-app name',
              pricePlaceholder: 'Search by price',
              posidPlaceholder: 'Search by POSID',
              barcodePlaceholder: 'Search by barcode',
              filterPlaceholder: 'Search',
              tagPlaceholder: 'All tags',
              isActivePlaceholder: 'All',
              updatedAtPlaceholder: 'Last Updated',
              isInStockPlaceholder: 'All statuses',
              isActive: 'Active',
              isNotActive: 'Inactive',
              isInStock: 'In Stock',
              isNotStock: 'Not In Stock',
              tags: 'tag | tags',
            },
            columns: {
              defaultName: 'Default name',
              inAppName: 'In-app name',
              price: 'Price',
              basePrice: 'Base price',
              posid: 'POSID',
              barcode: 'Barcode',
              tags: 'Filter tags',
              status: 'Status',
              inStock: 'In Stock',
              updatedAt: 'Updated',
            },
            expandRowAriaLabel: 'Expand row',
            collapseRowAriaLabel: 'Collapse row',
            selectItemAriaLabel: 'Select {name}',
            pageReport: "{'{first}'} - {'{last}'} of {'{totalRecords}'} items",
            swappedInTag: 'Swapped in',
            tableEmpty: 'Nothing Here Yet',
            tableLoading: 'Loading items data. Please wait.',
          },
          cpgSidebar: {
            headerTitle: 'Attach Consumer Packaged Goods',
            primaryAction: 'Attach',
            searchInfo:
              'Search for and select an existing Consumer Packaged Good from this Local Menu Group to attach to your brand.',
            searchPlaceholder: 'Search by item name',
            searchLabel: 'Search items to add',
            recentItems: 'Recently added items',
            searchResults: '{total} item(s) found',
            upc: 'UPC: {upc}',
            barcode: 'Barcode: {barcode}',
            minimumItemSelect: 'Select at least one item to attach',
            selectedValues: 'Selected ({total})',
            duplicateBarcodeText: 'This barcode already exists within this Brand',
            searchingItems: 'Searching for items...',
            createSuccess: '{total} items attached successfully',
            selectState: 'Select',
            unselectState: 'Unselect',
            noItems: 'No items available to add',
          },
        },
        generic: {
          altLanguages: {
            addCTA: 'Add language option',
            langOptionLabel: 'Language option',
            langOptionPlaceholder: 'Choose a language option',
            deleteCTA: 'Remove language option',
            optionLabels: {
              fr: 'French',
              kvi: 'KVI',
              es: 'Spanish',
            },
          },
          syncToGlobal: {
            syncCTA: 'Sync changes',
            undoSyncCTA: 'Undo sync',
          },
          statusChip: {
            label: 'Out of stock today',
            tooltip: 'Marked as out of stock in KDS. Will be back active tomorrow.',
          },
          taxTagCode: {
            label: 'Tax tag code',
            activeSwitchLabel: 'Tax exempt',
            placeholder: 'Add a tax tag code',
            exemptValue: 'EXEMPT',
          },
          tags: {
            label: 'Filter tags',
            tagsPlaceholder: 'Select or type in a new one',
            tagsPlaceholderSelected: '{total} tag(s)',
            tagsListAriaLabel: 'Filter tags list',
          },
          multipleValues: '(Multiple values)',
          kdsName: {
            label: 'Name on KDS',
            placeholder: 'Enter KDS name',
          },
          receipt: {
            receiptName: 'Name on receipt',
            receiptText: 'Enter receipt name',
          },
          aiGeneration: {
            header: 'AI IMAGE GENERATOR',
            generate: 'Generate an image',
            banner: {
              inAppName: 'In-app name',
              modifierGroups: 'Modifier groups',
              description: 'Description',
              text: `The description is generated with AI using the {fieldName1} and {fieldName2} details. To generate an AI image, both the {fieldName1} and {fieldName3} are required. Note that the AI's interpretation may vary with complex or abstract ideas`,
            },
          },
          menuWorksCreate: {
            back: 'Back',
            createEntity: 'Create {entityType}',
            mrn: 'MRN',
            name: '{entityType} name',
            label: 'In-app name',
            nameOnKds: 'Name on KDS',
            nameOnReceipt: 'Name on receipt',
            description: 'Description',
            ingredients: 'Ingredients',
            smartTags: 'Smart tags',
            allergens: 'Allergen tags',
            calories: 'Calories',
            cals: '{value} Cals',
            weight: 'Weight amount',
            cost: 'Cost per serving',
            gross: 'Gross profit',
            grossPlaceholder: '(None)',
            margin: 'Margin',
            price: 'Price',
            basePrice: 'Base price',
            marginPlaceholder: '- %',
            primaryAction: 'Create {entityType}',
            cancelAction: 'Go back',
          },
        },
        menuWorks: {
          syncHeaderTitle: 'Sync Menuworks Info',
          syncInfo: `You can sync MenuWorks info to your item. Enter your MRN (Master Reference Number). It won't overwrite any of your work.`,
          attributesTitle: 'Item attributes',
          mrn: 'MRN',
          mrnPlaceholder: '1234567890',
          syncData: 'Sync data',
          portionQuantity: 'Portion quantity',
          portionQuantityPlaceholder: 'Add a value',
          unitOfMeasurement: 'Unit of Measurement',
          unitOfMeasurementPlaceholder: 'Select a unit',
          calories: 'Calories',
          caloriesPlaceholder: 'Add calories',
          cost: 'Cost per serving',
          costPlaceholder: 'None yet',
          syncError: "That didn't sync. Check your info and try again.",
          overwriteLabel: 'Overwrite current values',
          menuWorksValues:
            'The following data will be overwritten: \n Name \n Calories \n Weight \n Description \n Portion quantity \n Unit of measurement \n Ingredients \n Allergens \n Smart tags',
          createDialog: {
            title: 'Create {entityType}',
            inputLabel: 'MenuWorks product',
            inputLabelMrnOnly: 'MenuWorks Recipe Number (MRN)',
            inputPlaceholder: 'Example: 34567, or Chicken noodle soup',
            inputPlaceholderMrnOnly: 'Enter MRN (Example: 12345 or 123.45)',
            inputDescription: 'Syncing pulls ingredients, cost, nutrition, and more',
            inputDescriptionMrnOnly:
              'Using an MRN can save time, syncing ingredients for the item, cost and more',
            getMrnInfoBtnLabel: 'Get MRN info',
            useMrnBtnLabel: 'Use MRN',
            useThisMrnBtnLabel: 'Use this MRN',
            goBackBtnLabel: 'Go back',
            searchBtnAriaLabel: 'Search MenuWorks products',
            suggestedHeader: 'MenuWorks suggestions',
            suggestionDescription: 'Select your MRN product from this list or search for a new one',
            searchInsteadBtnLabel: 'Search for a new product',
            manualItemCreateBtnLabel: 'Create {entityType} manually',
            invalidMRN: 'Double-check the MRN and try again. We couldn’t find that number',
            menuworksDown: 'Menuworks is temporarily unavailable',
            loadingText: 'Syncing MenuWorks info...',
          },
          createSuccessDialog: {
            title: '{entityType} Created!',
            createAgainBtn: 'Create another {entityType}',
            goToItemBtn: 'Go to {entityType}',
            mainText: ` is now in your brand's {entityType}s`,
          },
        },
        activityLog: {
          table: {
            title: 'Activity Log',
            tableEmpty: 'No activities yet',
            pageReport: "{'{first}'} - {'{last}'} of {'{totalRecords}'} events",
            columns: {
              dateTime: 'Timestamp',
              description: 'Activity description',
              details: 'Activity details',
              detailsCTA: 'Show details',
            },
            filters: {
              keywordPlaceholder: 'Search activity description',
              usernamePlaceholder: 'All users',
              statusTypePlaceholder: 'All activities',
            },
            statusTypes: {
              updates: 'Updates',
              create: 'Create',
              delete: 'Delete',
              scheduling: 'Scheduling',
              publish: 'Publish',
              globalUpdates: 'Global updates',
              syncChannel: 'Sync channel',
              import: 'Import',
            },
            activityDescription: {
              entityDeletedWarning: '{deletedBy} then deleted the {entityType} {date}', // for today and yesterday
              entityDeletedWarningOn: '{deletedBy} then deleted the {entityType} on {date}', // for other days
            },
          },
          errorSidebar: {
            title: 'Activity Details',
            processId: 'Process ID',
            processIdCopyAriaLabel: 'Copy Process ID',
            processIdCopyToast: 'Process ID copied to clipboard',
            processIdCopyErrorToast: 'Failed to copy process ID',
            infoLabel: 'Troubleshooting info',
            infoBlurb:
              'You can copy this info into a ticket with the Digital Care Team to help resolve the issue.',
            infoCopyCTA: 'Copy info',
            activitiesLabel: 'Related activities',
            infoCopyToast: 'Troubleshooting info copied to clipboard',
            infoCopyErrorToast: 'Failed to copy troubleshooting info',
            failedItemsLabel: 'Failed items',
            failedModifiersLabel: 'Failed modifiers',
          },
          globalChangesSidebar: {
            title: 'Global Menu Updates',
          },
          detailsSidebar: {
            title: 'Activity Details',
            affectedItemsLabel: 'Affected items',
            affectedModifiersLabel: 'Affected modifiers',
          },
        },
      },
    },
    entityManagement: {
      localGroupBreadcrumb: 'Local Menu Groups',
      globalGroupBreadcrumb: 'Global Menu Groups',
      createEntityHeader: 'Create New {entityType}',
      actionLabel: 'Save',
      cancelLabel: 'Cancel',
      duplicateAriaLabel: 'Duplicate',
      actionSuccessToast: "{entityType} '{entityName}' saved successfully",
      validationFailed: 'There was an error with the form. Please check the fields and try again.',
      entities: {
        item: 'Item',
        modifier: 'Modifier',
        modifierGroup: 'Modifier Group',
        category: 'Category',
        menu: 'Menu',
      },
      menuWorks: {
        connected: 'Connected and synced to MRN {mrn}.',
        connectedWithParent:
          'Connected and synced to MRN {mrn}. This item or modifier is from a Global menu. It can’t be disconnected.',
        disconnected: 'Not connected to a MenuWorks Recipe Number',
        disconnectedWithParent:
          'Not connected to MRN. This item or modifier is from a Global menu. To connect an MRN, duplicate it to your local menu.',
        connectAction: 'Connect',
        disconnectAction: 'Disconnect MRN',
        nutritionLabelsConnectLabel: 'Connect to MRN to have more nutrition facts and ingredients',
        resyncAction: 'Check for updates',
        syncWithMenuWorksAction: 'Sync with MenuWorks',
        connectedNotSyncedMain: 'Connected to MRN {mrn}. Sync to get MenuWorks updates.',
        connectedNotSyncedWithParentMain:
          'Connected to MRN {mrn}. This item or modifier is from a Global menu. It can’t be disconnected.',
        lastSyncNone: 'Last MenuWorks sync: None',
        lastSyncAt: 'Last MenuWorks sync: {date}',
        justNow: 'Just now',
        today: 'Today',
        syncInfo: `Connecting to MenuWorks with a MenuWorks Recipe Number (MRN) gives you access to item updates`,
        syncUpdated: `MenuWorks details updated`,
        noUpdatesFound: 'No updates found',
        nutritionValuesUpdated: 'Nutrition values updated',
        iconsValuesUpdated: 'MenuWorks icons updated.',
        syncDialog: {
          connectHeader: 'Connect to MRN',
          connectLoadingHeader: 'Getting MRN info...',
          resyncLoadingHeader: 'Checking for MRN updates...',
        },
        syncDetails: {
          connectHeader: 'Connect to MRN',
          resyncHeader: 'MRN Updates',
          connectPrimaryActionLabel: 'Connect to MRN',
          resyncPrimaryActionLabel: 'Apply changes',
          connectWarning: `MenuWorks updates will replace item details but won't override modifiers or add-ons that don’t show here. `,
          connectItemModifierWarning: `MenuWorks updates replace item or modifier details, but won’t change prices, add-ons, or other local attributes you can edit.`,
          resyncWarning: `MenuWorks updates will add or replace only the {entityType} details shown. `,
        },
        confirmDialog: {
          header: 'Continue to disconnect MRN?',
          message:
            'Your Nextep settings will reset to default. If you decide to reconnect later, you’ll need to set them up again. This change can’t be undone.',

          acceptLabel: 'Continue',
          rejectLabel: 'Cancel',
        },
        syncInProgressLabel: 'Syncing with MenuWorks',
        syncInProgressInfo: 'MenuWorks changes are unavailable while syncing',
      },
      aiImageGeneration: {
        confirmDialog: {
          title: 'Save {entityType} without image update?',
          text: "Your AI image isn't ready and won't be saved. If you have a current image, it will stay in place.",
          confirmLabel: 'Save anyway',
        },
        errorMessages: {
          vertexSafetyFilterBlockedImages: 'Vertex safety filter blocked images',
          toastMessage: "Image couldn't be created",
          toastDetail: 'Update your description and try again',
          messageDetails:
            "We can't generate this image - description may contain explicit content.",
          messageDetailsAction: 'Update the description and try again',
        },
      },
      panels: {
        entityType: '{entity}',
        names: '{entity} names',
        pricing: 'Pricing',
        priceManagement: 'Price management',
        priceLevels: 'Price levels',
        reporting: 'Reporting',
        display: '{entity} display',
        generateItemImage: 'Generate item image',
        modifierGroups: 'Modifier groups',
        tags: 'Tags',
        labels: 'Labels',
        nutritionLabels: 'Nutrition facts & labels',
        setup: '{entity} setup',
        altLanguages: 'Alternative languages',
        dangerous: 'Dangerous zone',
        dangerousInfo: 'This is a dangerous zone. Be careful with your actions.',
        requiredField: `* 1 required field`,
        requiredFields: `* {total} required fields`,
      },
      fields: {
        nameLabel: 'Default name',
        namePlaceholder: 'Enter a default name',
        isActiveAriaLabel: 'Status',
        imageLabel: 'Image',
        aiImagePromptLabel: 'Describe your {entityType} in detail',
        aiImagePromptHelperText: 'Required to generate image',
        aiImagePromptPlaceholder:
          'Example: A juicy beef patty topped with melted cheddar, crispy bacon, fresh lettuce, and tomato, all tucked into a soft toasted bun.',
        aiImagePromptEllipsis: '...',
        aiImagePromptInfoMessage: 'Description has been shortened. Edit or generate image',
        aiImageAspectRatioLabel: 'Image ratio',
        aiImageBackgroundColorLabel: 'Background color',
        aiImageLayoutLabel: '{entityType} layout (Optional)',
        aiImageLayoutItemOnlyLabel: 'Item only',
        aiImageLayoutPlatedLabel: 'On a plate',
        generateAiImageButton: 'Generate image',
        imageGeneratingInfo: 'Your image will be ready in about 30 seconds',
        imageGeneratedToast: 'Generated image is ready',
        imageGeneratedToastDetail: 'Find it in item display',
        generatedImageLabel: 'Generated image',
        generatedImageCancelButton: 'Cancel',
        generatedImageKeepCurrentButton: 'Keep current',
        generatedImageAcceptButton: 'Use this image',
        chooseAndGenerateAnotherImageInfo:
          'Choose an image for your menu. You can generate a new image at anytime',
        generateAnotherImageInfo: 'You can generate a new image at anytime',
        descriptionLabel: 'Description on menu',
        descriptionHelperText: '200 characters best for easy reading',
        descriptionCounterText: 'Character count: {currentCharCount}',
        descriptionPlaceholder:
          'Example: A flame-grilled beef patty topped with crispy onion strings, smoky BBQ sauce, melted cheddar, and crunchy pickles, sitting on a toasted brioche bun.',
        inAppNameLabel: 'In-app name',
        inAppNamePlaceholder: 'Enter an in-app name',
        kdsLabel: 'Name on KDS',
        kdsPlaceholder: 'Enter a name to use on KDS',
        receiptLabel: 'Name on receipt',
        receiptPlaceholder: 'Enter a name to show on receipt',
        usingDefaultNamePlaceholder: 'Using default name: {name}',
        usingInAppNamePlaceholder: 'Using in-app name: {name}',
        priceLabel: 'Price',
        basePriceLabel: 'Base price',
        pricePlaceholder: '$Put a price',
        nextepPriceLabel: `Nextep {fieldName} price`,
        preSurcharge: 'Pre-surcharge',
        preSurchargePlaceholder: '$Put a price',
        posLabel: 'Name on POS',
        posPlaceholder: 'Enter a name to use on POS',
        postSurcharge: 'Post-surcharge',
        postSurchargePlaceholder: '$Put a price',
        priceForNone: 'Price for none',
        priceForLess: 'Price for less',
        priceForSide: 'Price for side',
        priceForMore: 'Price for more',
        priceForExtra: 'Price for extra',
        preSurchargeTooltip:
          'Add a custom price to this modifier\n which is applied until the \n surcharge limit has been reached.\n Normal price by default.',
        postSurchargeTooltip:
          'Add a custom price to this modifier\n which is applied after the \nsurcharge limit has been reached.\n Normal price by default.',
        costLabel: 'Cost',
        marginLabel: 'Margin',
        nextepMarginLabel: `Nextep {fieldName} margin`,
        notAvailable: '-',
        mealValueLabel: 'Meal value',
        mealValuePlaceholder: 'Add meal value',
        taxTagsLabel: 'Tax tags',
        taxTagsPlaceholder: 'Select a tax tag',
        reportingPrimary: 'Reporting category',
        reportingSecondary: 'Reporting subcategory',
        reportingPlaceholder: 'Select a category',
        reportingSecondaryPlaceholder: 'Search or type a subcategory',
        reportingEmpty: 'No results for this criteria. This will create a new report subcategory.',
        jdeLabel: 'JDE category (Canadian sites only)',
        jdePlaceholder: 'Choose a JDE category',
        nutritionLabelsTitle: 'Nutrition facts',

        caloriesLabel: 'Calories',
        caloriesPlaceholder: 'Add calories',
        caloriesSuffix: ' kcal',
        weightAmountLabel: 'Container weight',
        weightAmountPlaceholder: 'Add a value',
        weightTooltip:
          'Container weight is the weight of the container provided with the food item. Also known as Tare weight.',

        weightUnitLabel: 'Weight unit',
        weightUnitPlaceholder: 'Select a unit',
        findToAttach: 'Find {entityToAttach}s to attach',
        findToAttachPlaceholder: 'Search {entityToAttach}s for this {entityType}',
        attachLabel: '{entityToAttach}s attached to the {entityType}',
        attachPlaceholder: 'No {entityToAttach}s are attached to this {entityType}',
        globalIndicatorAriaLabel: 'Global parent indicator for {entity}',
        globalIndicatorAriaDescription:
          'This relationship is inherited from a global parent for {entity}',
        globalIndicatorTooltip: 'This relationship is inherited from a global parent',
        menuLabelsLabel: 'Menu labels',
        menuLabelsInfo:
          'Labels help guests identify dietary needs and featured programs on menu items',
        menuLabelsInfoInherited:
          'Labels are set up in the global menu, they cannot be modified, it helps guests identify dietary needs and featured programs on menu items',
        menuLabelsInfoEmpty: 'To set up menu labels, go to global menu group settings',
        removeLabelAriaLabel: 'Remove label {label}',
        addLabelsButton: 'Add labels',
        addLabelsDialogTitle: 'Add menu labels',
        addLabelsDialogDescription: '5 or fewer keeps items simple for guests to scan',
        addLabelsDialogPrimaryActionLabel: 'Add labels',
        addLabelsDialogSecondaryActionLabel: 'Cancel',
        ingredientsLabel: 'Ingredients',
        smartTagsLabel: 'Smart tags',
        allergensLabel: 'Allergen tags',
        barcodeLabel: 'Barcode',
        barcodePlaceholder: 'Add barcode',
        posidLabel: 'POSID',
        posidPlaceholder: 'POSID will be auto-generated',
        posidReadonlyLabel: 'POSID: {posid}',
        posidReadonlyPlaceholder: 'POSID: will be auto-generated',
        kitchenRouteLabel: 'Kitchen route',
        kitchenRoutePlaceholder: 'Select or create a kitchen route',
        isFeaturedLabel: 'Suggest item at Checkout',
        filteringTagsLabel: 'Filter tags',
        filteringTagsPlaceholder: 'Select or type in a new one',
        featuredTag: 'Suggested at checkout',
        taxTagCode: 'Tax tag code',
        taxTagCodePlaceholder: 'Add a tax tag code',
        taxTagJwo: 'JWO tax code',
        taxTagJwoPlaceholder: 'Select tax code',
        taxExempt: 'Tax exempt',
        priceLevelGlobalInfo:
          'Price levels help you group items into pricing tiers. Save and publish to reflect changes on local menu groups',
        priceLevelLocalInfo:
          'Price levels help you group items into pricing tiers. To manage price levels locally, go to local menu group settings',
        priceLevelEmptyInfo: `Price levels help you group items into pricing tiers. To manage price levels locally, go to {localOrGlobal} menu group settings`,
        altLangNameLabel: '{entityType} name',
        altLangNamePlaceholder: 'Create a name',
        altLangDescriptionLabel: '{entityType} description',
        altLangDescriptionPlaceholder: 'Add a description',
        servingSizeLabel: 'Serving size',
        nutritionFacts: {
          calories: 'Calories',
          totalFat: 'Total fat',
          saturatedFat: 'Saturated fat',
          transFat: 'Trans fat',
          totalCarbohydrate: 'Total carbohydrates',
          totalSugars: 'Total sugars',
          addedSugars: 'Added sugars',
          protein: 'Protein',
          dietaryFiber: 'Dietary fiber',
          sodium: 'Sodium',
          cholesterol: 'Cholesterol',
        },
      },
      delete: {
        deleteAction: 'Delete {entityType}',
        confirmHeader: 'Delete {entityName}?',
        confirmMessage: `This will permanently erase the {entityType}: {entityName}. It can't be undone.`,
        confirmAcceptLabel: 'Delete',
        confirmRejectLabel: 'Cancel',
        deleteSuccessToast: '{entityType} deleted successfully',
      },
      visibility: {
        hiddenLabel: 'Hidden on guest menu',
        shownLabel: 'Shown on guest menu',
        factsShownLabel:
          '{factsCount} fact shown on guest menu | {factsCount} facts shown on guest menu',
        allFactsShownLabel: 'All facts shown on guest menu',
        allFactsHiddenLabel: 'All facts hidden on guest menu',
        nutritionFactsShownTooltipTitle: 'Nutrition facts shown:',
        managedInGlobalMenuGroupTooltip: 'Managed in global menu group',
        managedInLocalMenuGroupTooltip: 'Managed in local menu group',
      },
    },
    menuWorksImport: {
      importButton: 'Import Items',
      importButtonWithCount: 'Import {count} Items',
      importDialog: {
        title: 'Import from MenuWorks',
        priceLabel: 'Price',
        typeLabel: 'Type',
        confirmButton: 'Import all',
      },
      unitIdLabel: 'MenuWorks unit',
      unitIdPlaceholder: 'MenuWorks unit',
      table: {
        title: 'MenuWorks import',
        maxSelectionReached: 'You can only select up to 10 products at a time.',
        actionBar: {
          totalSelected: '{total} products selected',
          importAction: 'Import',
        },
        searchLabel: 'Search by MRN or name',
        searchPlaceholder: 'Example: 43092, Burger',
        pageReport: "{'{first}'} - {'{last}'} of {'{totalRecords}'} products",
        tableEmpty: 'No matches found',
        tableLoading: 'Loading MenuWorks products...',
        columns: {
          MRN: 'MRN',
          name: 'Name',
          productType: 'Product Type',
          shortName: 'Short Name',
        },
      },
      importSuccess: 'Products imported successfully',
      syncStatus: {
        loading: 'Loading sync status...',
        refreshingCache: 'Syncing MenuWorks products: {count}/{total}',
        lastSuccess: 'New MenuWorks products may not appear right away.',
        refreshInfo: 'Refresh to sync latest.',
        failed: 'We had an issue syncing with MenuWorks. Refresh again if you like.',
        justNow: 'Just now',
        today: 'Today',
        triggerRefresh: 'Refresh',
      },
    },
    exportImport: {
      brand: {
        OR: 'OR',
        exportBtn: 'Export Brand',
        importBtn: 'Import Brand',
        exportImportHeader: 'Import / Export Brand',
        errorConfirm: 'Got it',
        cancel: 'Cancel',
        exportSuccess: 'Brand exported',
        importFileUploaded: 'File uploaded. Import will take a few moments.',
        exportFailed: 'Export failed',
        importFailed: 'Import failed',
        importFailedWithValidation:
          'Import file validation failed. See the validation Excel file for details.',
        errorDialog: {
          header: 'Try that again.',
          exportError: 'There was a glitch. Try again.',
          tryAgain: 'Try again',
          cancel: 'Cancel',
        },
        catalogVersionLabel: 'Export from backup version',
        catalogVersionPlaceholder: 'Latest version (default)',
        catalogVersionListAriaLabel: 'Catalog version list',
        catalogVersionInfo:
          'A new backup version is created each time the brand is published.\nSelect a version to export the brand as it was at that point in time.',
      },
      menu: {
        ariaLabel: 'Import / Export actions',
        exportBrandLabel: 'Import/export brand',
        menuWorksImportLabel: 'Import from MenuWorks',
      },
      menuWorks: {
        title: 'Import from MenuWorks',
        subtitle: 'Import menus from connected MenuWorks Units',
        importAction: 'Import',
        unitField: {
          label: 'MenuWorks unit number',
          placeholder: 'Select a MenuWorks unit',
        },
        noUnit: {
          title: 'No MenuWorks Unit Available',
          bodyLocal:
            'Importing MenuWorks items requires a connected MenuWorks unit. Connect one from the Local Menu Group settings.',
          bodyGlobal:
            'Importing MenuWorks items requires a connected MenuWorks unit. Connect one from the Global Menu Group settings.',
          cancel: 'Cancel',
          connect: 'Connect now',
          illustrationAlt: 'No MenuWorks unit illustration',
        },
        itemGroupField: {
          label: 'Item group',
          placeholder: 'Select an item group to import',
        },
        noItemGroupWarning:
          'No item groups are available from this selected unit. Choose another one to continue',
      },
    },
  },
};
